<h2 mat-dialog-title class="dialog-title">
  <mat-icon aria-hidden="true">event_busy</mat-icon>
  Locked schedule dates
</h2>

<mat-dialog-content class="dialog-content">
  @if (dates.length === 0) {
    <p class="empty-msg">No upcoming locked dates for this station.</p>
  } @else {
    <p class="dialog-hint">Tap remove to unlock a date. Only auto-filled promos from lockout are removed.</p>
    <ul class="date-list">
      @for (d of dates; track d) {
        <li class="date-row">
          <span class="date-label">{{ d }}</span>
          <button
            mat-icon-button
            type="button"
            class="unlock-btn"
            [disabled]="unlockingDate !== null"
            [attr.aria-label]="'Unlock ' + d"
            (click)="unlockDate(d, $event)"
          >
            @if (unlockingDate === d) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              <mat-icon>close</mat-icon>
            }
          </button>
        </li>
      }
    </ul>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button type="button" (click)="close()">Done</button>
</mat-dialog-actions>
